import { shouldUserSeeBoostedListings } from '../helpers';

import { useFetchSellerOnboardingStatus } from '@/modules/sellerOnboarding/hooks/useFetchSellerOnboardingStatus';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useBoostedListingAccess() {
  const [, user] = useCurrentUser();
  const { data: sellerStatus } = useFetchSellerOnboardingStatus(user?.id);
  const isStripeConnected = sellerStatus?.data?.stripe?.isConnected;

  const hasBoostedListingsAccess =
    shouldUserSeeBoostedListings(user?.date_joined) ||
    Boolean(isStripeConnected);

  return { hasBoostedListingsAccess };
}
